// components/ArticleList.tsx
import React, { useEffect } from 'react';
import { TFunction, useTranslation } from 'next-i18next';
import Texto from '@/components/elements/Texto';
import { textoBotones, textosMini } from '@/constants/Dimens';
import { Card } from '@mui/material';
import ComponentePuntuacion from './ComponentePuntuacion';
import TituloDescripcion from '@/components/elements/TituloDescripcion';
import Boton from '@/components/elements/Boton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import { apellidoConPunto, esPremium, primeraLetraMayuscula } from '@/util/StringsUtil';
import ImageRound from '@/components/elements/ImageRound';
import { comprobarAvatar } from '@/util/Articulos';
import { azul, lightGray, oro, white } from '@/constants/Colors';
import BadgeCustom from '@/components/elements/Badge';
import { useServices } from '@/context/ServicesProvider';
import { AxiosResponse } from 'axios';
import { UserDataPerfil } from '@/objects/User';
import { dateToTextTForm } from '@/util/MagicDate';

interface ArticleListProps {
  id_usuario: number,
  modo_catalogo?: boolean,
  modo_seguimiento?: boolean;
}

const CardUser: React.FC<ArticleListProps> = ({ id_usuario, modo_catalogo = false, modo_seguimiento = false }) => {

  const { t } = useTranslation();

  const { usersQueries } = useServices();
  const [datosUsuarioRemote, setDatosUsuarioRemote] = React.useState<UserDataPerfil>();

  useEffect(() => {
    if (!id_usuario) return;
    usersQueries!.obtenerDatosUsuarioPerfilPublico(id_usuario).then((response: AxiosResponse<UserDataPerfil>) => {
      if (response.status === 200) {
        //alert('Datos del usuario obtenidos correctamente');
        setDatosUsuarioRemote(response.data);
      }
    }).catch((error) => {
      console.log('Error al obtener datos del usuario', error);
    });
  }, [id_usuario]);

  function abrirPerfilUsuario() {
    window.location.href = "/individuales/" + id_usuario;
  }
  

  return (
    <Card style={{ display: 'flex', flexDirection: 'column', width: "380px", padding: "10px" }}>

      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ display: 'flex', flexDirection: 'column', width: "60%" }}>
          {!modo_catalogo && !modo_seguimiento && (
            <TituloDescripcion>{t("contenido:user.card_user.libro_add_por")}</TituloDescripcion>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', marginTop: "5px", justifyContent: 'flex-end' }}>
            <Texto fontSize={textoBotones}>{apellidoConPunto(primeraLetraMayuscula(datosUsuarioRemote?.name || ''))}</Texto>
            <div style={{ marginTop: "10px" }}>
              <Boton startIcon={<AccountBoxIcon />} height={"30px"} fullWidth={true} texto={t("contenido:user.card_user.ver_todos_libros")} onClick={abrirPerfilUsuario} />
            </div>
            <div style={{ marginTop: "10px" }}>
              <Texto fontSize={textosMini}>{t("contenido:user.card_user.miembro_desde", { fecha: datosUsuarioRemote ? dateToTextTForm(datosUsuarioRemote.fecha_miembro, t) : '' })}</Texto>
            </div>
          </div>
        </div>
        <div style={{ width: "40%", display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center' }}>
          <div style={{ display: 'flex', justifyContent: 'center', }}>
            <ImageRound src={comprobarAvatar(datosUsuarioRemote?.image || '')} title={t("contenido:user.card_user.title_user")} alt={"contenido:user.card_user.alt_user"} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: "center", marginTop: "10px", marginBottom: "10px" }}>
            <BadgeCustom texto={esPremium(datosUsuarioRemote?.premium) ? t('common:caracteristicas.premium') : t('common:caracteristicas.no_premium')} color={white} backgroundColor={esPremium(datosUsuarioRemote?.premium) ? oro : lightGray} />
            {datosUsuarioRemote?.esTienda == 1 &&
              <BadgeCustom texto={t('common:caracteristicas.tienda')} color={white} backgroundColor={azul} />
            }

          </div>
          <ComponentePuntuacion id_usuario={id_usuario} t={t} />
        </div>
      </div>

    </Card>
  );
}

export default CardUser;


